export const PHOTO_MAX_BYTES = 180 * 1024;
export const jsonBytes = value => new TextEncoder().encode(JSON.stringify(value)).length;

// Leave room for the operation envelope and audit metadata. Never alter a
// signed/frozen operation to make it smaller; checks happen before preparation.
export function intakeSizeError(draft, body) {
  if (jsonBytes(draft) > 950 * 1024 || jsonBytes(body) > 4.8 * 1024 * 1024) {
    return 'Your answers are still on this page, but the attached photos make the intake too large to save. Go back and replace the photos with close-up pictures of each card. If it is still too large, keep this page open and ask the front desk for help.';
  }
  return null;
}

export async function prepareIntakePhoto(file) {
  if (!file?.type?.startsWith('image/')) throw Error('Choose a photo of the card or document.');
  if (file.size > 30 * 1024 * 1024) throw Error('This photo is too large to open. Take a new close-up photo; your other answers are unchanged.');
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = () => reject(Error('This photo could not be opened. Try a JPEG photo or take a new picture. Your other answers are unchanged.'));
      img.src = url;
    });
    if (!img.naturalWidth || !img.naturalHeight) throw Error('This photo is empty. Please choose another.');
    for (const edge of [1600, 1280, 1024]) {
      const scale = Math.min(1, edge / Math.max(img.naturalWidth, img.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
      const ctx = canvas.getContext('2d');
      if (!ctx) throw Error('Photo preparation is unavailable. Your answers are unchanged; ask the front desk for help.');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      for (const quality of [0.85, 0.72, 0.6]) {
        const data = canvas.toDataURL('image/jpeg', quality);
        if (data.startsWith('data:image/jpeg;base64,') && data.length <= PHOTO_MAX_BYTES) return data;
      }
    }
    throw Error('This photo has too much detail to save clearly. Take a close-up of just the card. Your other answers are unchanged.');
  } finally { URL.revokeObjectURL(url); }
}
